import React, { FC } from 'react';
import { ThankYouFields } from './types/thankYou.types';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import CTA from '../../../@shared/CTA';
import ctaTypes from '../../../../enums/CTA.enums';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import './styles.scss';

const ThankYou: FC<ThankYouFields> = (props) => {
  const { redirectionLink, message = '', title } = props;
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']})`);
  const link = {
    value: {
      text: redirectionLink?.description || redirectionLink?.alternateText,
      href: redirectionLink?.link
    }
  };


  return (
    <section className={'thank-you'}>
      <div className={'thank-you__content'}>
        <div className="thank-you__icon-wrapper">
          <Icon iconName={'action-checkmark-circle'} size={iconSize.xlg} color="success" />
        </div>
        <h3 className={'thank-you__title'}>{title}</h3>
        <RichText tag="div" field={{value: message}}  className={'thank-you__message'} />
        <div className={'thank-you__buttons'}>
          {(link?.value?.text && link?.value?.href) && (
            <CTA
              type={ctaTypes.primaryOrange}
              field={link}
              target={targetLinkdsk(link, isDesktop)}
              extraClassName={'thank-you__cta-primary'}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default ThankYou;
